import { render, staticRenderFns } from "./UploadDatasetTsModal.vue?vue&type=template&id=8140e80a&scoped=true"
import script from "./UploadDatasetTsModal.vue?vue&type=script&lang=js"
export * from "./UploadDatasetTsModal.vue?vue&type=script&lang=js"
import style0 from "./UploadDatasetTsModal.vue?vue&type=style&index=0&id=8140e80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8140e80a",
  null
  
)

export default component.exports